import { makeAutoObservable } from 'mobx';

import { ApiRoutes } from '../../config/ApiRoutes';
import { UsersDTO } from '../../types';
import { RootStore } from '..';

export class AdminUsersApiStore {
  constructor(public rootStore: RootStore) {
    makeAutoObservable(this, { rootStore: false });
  }

  getAdminList = (
    params: {
      limit: number;
      nextLink: string;
      sortBy: string;
      sortDirection: string;
    },
    status: string,
  ) => {
    const {
      GetList: { Endpoint, Method },
    } = ApiRoutes.Admins;

    return this.rootStore.apiStore.call<UsersDTO>({
      method: Method,
      params,
      url: status === 'Users' ? Endpoint : Endpoint.concat('/roles'),
    });
  };

  getAdminUsersList = (params: {
    limit: number;
    nextLink: string;
    sortBy: string;
    sortDirection: string;
  }) => {
    const {
      GetAdminUsersList: { Endpoint, Method },
    } = ApiRoutes.Admins;

    return this.rootStore.apiStore.call<UsersDTO>({
      method: Method,
      params,
      url: Endpoint,
    });
  };

  getAdminRolesList = (params: { limit: number; nextLink: string }) => {
    const {
      GetAdminRolesList: { Endpoint, Method },
    } = ApiRoutes.Admins;

    return this.rootStore.apiStore.call<UsersDTO>({
      method: Method,
      params,
      url: Endpoint,
    });
  };

  getAdminsBySearch = (params: {
    limit: number;
    nextLink: string;
    name: string;
    sortBy: string;
    sortDirection: string;
  }) => {
    const {
      GetList: { Endpoint, Method },
    } = ApiRoutes.Admins;

    const restParams = this.objClean({ ...params });

    return this.rootStore.apiStore.call<UsersDTO>({
      method: Method,
      params: {
        ...restParams,
      },
      url: Endpoint,
    });
  };

  getAdminsUsersBySearch = (params: {
    limit: number;
    nextLink: string;
    firstName: string;
    lastName: string;
    email: string;
    contactType: string;
  }) => {
    const {
      GetAdminUsersList: { Endpoint, Method },
    } = ApiRoutes.Admins;

    const restParams = this.objClean({ ...params });

    return this.rootStore.apiStore.call<UsersDTO>({
      method: Method,
      params: {
        ...restParams,
      },
      url: Endpoint,
    });
  };

  createAdminUsers = (selectedList: any) => {
    const {
      CreateAdminUsers: { Endpoint, Method },
    } = ApiRoutes.Admins;

    return this.rootStore.apiStore.call<any>({
      data: selectedList,
      method: Method,
      url: Endpoint,
    });
  };

  deleteAdmin = (id: string) => {
    const {
      DeleteAdmins: { Endpoint, Method },
    } = ApiRoutes.Admins;
    const deleteAdminsUrl: string = Endpoint.concat(id);

    return this.rootStore.apiStore.call<any>({
      method: Method,
      url: deleteAdminsUrl,
    });
  };

  updateAdmin = (user: any) => {
    const {
      UpdateAdmins: { Endpoint, Method },
    } = ApiRoutes.Admins;
    const editAdminUserUrl: string = Endpoint.concat(user.adminId);

    return this.rootStore.apiStore.call<any>({
      data: {
        email: user.email,
        role: user.role,
        userContactGrantedId: user.userContactGrantedId,
      },
      method: Method,
      url: editAdminUserUrl,
    });
  };

  createAdminRoles = (data: any) => {
    const {
      CreateAdminRoles: { Endpoint, Method },
    } = ApiRoutes.Admins;

    return this.rootStore.apiStore.call<any>({
      data: data,
      method: Method,
      url: Endpoint,
    });
  };

  resendPortalInvitation = (data: any) => {
    const {
      ResendPortalInvitation: { Endpoint, Method },
    } = ApiRoutes.Admins;

    return this.rootStore.apiStore.call<any>({
      data: data,
      method: Method,
      url: Endpoint,
    });
  };

  objClean(obj: any) {
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key) && !obj[key]) {
        delete obj[key];
      }
    }
    return obj;
  }
}
